// Centralized configuration for frontend
// Pulls from Azure App Service app settings via environment variables exposed at build/runtime

// Determine backendBaseUrl from the current request URL
let backendBaseUrl = 'https://backend.productwidget.tech';

try {
  const href = typeof window !== 'undefined' && window.location ? window.location.href : '';
  if (href.includes('localhost')) {
    backendBaseUrl = 'http://localhost:5262';
  } else if (href.includes('-dev')) {
      backendBaseUrl = 'https://backend-dev.productwidget.tech';
  } else {
      backendBaseUrl = 'https://backend.productwidget.tech';
    }


  //console.log(href);
  // Optional one-time debug
  //console.log('[config] backendBaseUrl:', backendBaseUrl, 'from href:', href);
} catch {

}

export { backendBaseUrl };
